import { render } from "./PageArticle.vue?vue&type=template&id=5ae4beaa"
import script from "./PageArticle.vue?vue&type=script&lang=js"
export * from "./PageArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__